import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiJson } from '../api/client.js';

export function MyToolsPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    apiJson('/api/my/tools')
      .then(setData)
      .catch((e) => setError(e.message));
  }, []);

  if (error) return <p className="err">{error}</p>;
  if (!data) return <p className="muted">Loading tools…</p>;

  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">Tools & Links</h2>
      <div className="auth-card flat" data-tour="tools-list">
        <h3>Agency resources</h3>
        {data.documents?.length ? (
          <ul>
            {data.documents.map((d) => (
              <li key={d.id}>
                <a href={d.url} target="_blank" rel="noreferrer">
                  {d.label}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <p className="muted">No shared tools yet.</p>
        )}
      </div>
      {data.project_links?.length ? (
        <div className="auth-card flat" style={{ marginTop: '1rem' }}>
          <h3>Project quick links</h3>
          {data.project_links.map((group) => (
            <div key={group.project_id} style={{ marginBottom: '1rem' }}>
              <strong>
                <Link to={`/my/projects/${group.project_id}`}>{group.project_name}</Link>
              </strong>
              <ul>
                {group.quick_links.map((l, i) => (
                  <li key={i}>
                    <a href={l.url} target="_blank" rel="noreferrer">
                      {l.label}
                    </a>
                  </li>
                ))}
                {group.integration_tool_links?.map((l) => (
                  <li key={l.key}>
                    <a href={l.url} target="_blank" rel="noreferrer">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
